/* eslint-disable no-console */
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import {
  Autocomplete,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  Link,
  MenuItem,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useGetCountriesQuery, useGetSitesQuery, useGetStudiesQuery } from 'src/components/Services/Utils';
import { AppState, store, useAppSelector } from 'src/store';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setMoveTabValue } from 'src/store/MoveTab';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocumentViewerComponent from '../documentViewer/DocumentViewer';
import DocumentConfigs from './../configs/documentConfigs';
import { DocumentUploadComponent } from './component/DocumentUploadComponent';
import './DocumentUpload.scss';
import { DocumentUploadList } from './DocumentUploadList';
import DocManagementService from './service/DocManagementService';
import { VersionControl } from './VersionControl';
import { hideLoader, showLoader } from 'src/store/Loader';

export const DocumentUpload = (props: any) => {
  const isPageFirstRendered = useRef({ isRendered: false });
  const tmfLevelConfigs = DocumentConfigs.tmfLevelConfigs;
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const docService = new DocManagementService();
  const { t } = useTranslation();
  const tmfLevelLocale: any = t('tmfLevelConfigs', {
    returnObjects: true
  });
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }

  const dispatch = useDispatch();
  const [dataGridComponent, setDataGridComponent] = useState(props.dataGridComponent ? false : true);
  const [documentToDisplay, setDocumentToDisplay] = useState<any>([]);
  const [openVersion, setOpenVersion] = useState(false);
  const [openEditDocVersion, setOpenEditDocVersion] = useState(props.openVersion ? true : false);
  const [selectData, setSelectData] = useState<any>([]);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [enable, setEnable] = useState<boolean>(false);
  const [studyList, setStudyList] = useState<any>([]);
  const [artifactName, setArtifactName] = useState<any>();
  const [list, setList] = useState([]);
  const [resData, setResData] = useState<any>(null);
  const [isFileUploaded, setFileUploaded] = useState<any>(null);
  const [result, setResult] = useState<any>([]);
  const [tmfLevelLoading, setTmfLevelLoading] = useState(false);
  const [artifactsError, setArtifactsError] = useState(false);
  const [editDoc, setEditDoc] = useState<any>({});
  const [disableSave, setDisableSave] = useState(true);
  const { row, isEdit } = editDoc;
  const [IsVersionCheck, setIsVersionCheck] = useState(false);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [loading, setLoading] = useState<any>(false);
  const [styleUpload, setStyleUpload] = useState('uploadFile');
  const [isUploaded, setUploaded] = useState<boolean>(false);
  const [currentSite, setCurrentSite] = useState('');
  const [isEdited, setIsEdited] = useState<boolean>();
  const [disableDropzone, setDisableDropzone] = useState<boolean>(true);
  const [addonStyle, setAddonStyle] = useState(' noUploadFile');
  const [rowCount, setRowCount] = useState<number>(0);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState(0);
  const [isFileUploading, setFileUploading] = useState<boolean>(false);

  const InitialState = {
    tmf_artifact_number: '',
    tmf_document_name: '',
    tmf_document_type: '',
    tmf_document_subtype: '',
    tmf_doc_date: '',
    tmf_doc_country: '',
    tmf_doc_study: '',
    tmf_doc_site: '',
    tmf_doc_level: '',
    tmf_artifact_name: '',
    tmf_doc_version_number: 0,
    tmf_doc_milestone: ''
  };
  const [metaData, setMetaData] = useState<any>(InitialState);
  const rowDetails: any = useSelector((state: AppState) => state.rowDetail);

  useEffect(() => {
    if (rowDetails.data[0] != null && rowDetails.data[0] != undefined) {
      setIsVersionCheck(true);
      setMetaData({
        ...metaData,
        id: rowDetails.data[0]?.id,
        tmf_artifact_number: rowDetails.data[0]?.tmf_artifact_number,
        tmf_document_type: rowDetails.data[0]?.tmf_doc_type,
        tmf_document_subtype: rowDetails.data[0]?.tmf_doc_subtype,
        tmf_doc_country: rowDetails.data[0]?.tmf_doc_country,
        tmf_doc_study: rowDetails.data[0]?.tmf_doc_study,
        tmf_doc_site: rowDetails.data[0]?.tmf_doc_site,
        tmf_doc_level: rowDetails.data[0]?.tmf_doc_level,
        tmf_artifact_name: artifactName ? artifactName : rowDetails.data[0]?.tmf_artifact_name,
        tmf_doc_milestone: rowDetails.data[0]?.tmf_doc_milestone,
        fileId: rowDetails.data[0]?.fileId,
        tmf_doc_viewer_req_certified_copy: rowDetails.data[0]?.tmf_doc_viewer_req_certified_copy,
        tmf_document_id: rowDetails.data[0]?.tmf_document_id
      });
      setCurrentStudy(rowDetails.data[0]?.tmf_doc_study);
      setCurrentCountry(rowDetails.data[0]?.tmf_doc_country);
      setArtifactName(artifactName ? artifactName : rowDetails.data[0]?.tmf_artifact_name);
    }
  }, [rowDetails]);

  const onFileUploadSuccess = (fileUploaded: any) => {
    setFileUploaded(fileUploaded);
    setMetaData({ ...metaData, tmf_doc_version_number: `1.0`, tmf_doc_date: new Date() });
  };

  const handleUploadFile = async (Res: any, Meta: any, artifactName: any, isSubmit: boolean) => {
    // called when submit button is clicked
    dispatch(showLoader());
    const params = {
      module_section_related: 'DocumentUpload',
      parent_entity_related: 'Document Uploaded'
    };
    const response: any = await docService.fileUpload(
      isFileUploaded,
      progress => {
        setProgress(progress);
      },
      metaData.tmf_doc_study ? metaData.tmf_doc_study : currentStudy,
      metaData.tmf_doc_country ? metaData.tmf_doc_country : currentCountry,
      metaData.tmf_doc_site ? metaData.tmf_doc_site : currentSite,
      metaData.tmf_doc_level ? metaData.tmf_doc_level : TmfLevel,
      params
    );
    setFileUploading(false);
    if (response.data) {
      const data = response.data.data;
      setResData(data);
      setConfirmExitValue(dispatch, true);
      setMoveTabValue(dispatch, false);
      metaData.tmf_doc_version_number = data.tmf_doc_version_number;
      metaData.tmf_doc_date = data.updated_on;
      const docData: any = {
        file_master_id: data.id,
        document_data: {
          tmf_artifact_number: Meta.tmf_artifact_number,
          tmf_document_name: Meta.tmf_document_name,
          tmf_doc_type: Meta.tmf_document_type,
          tmf_doc_subtype: Meta.tmf_document_subtype,
          tmf_doc_viewer_req_certified_copy: 'N',
          tmf_doc_status: 'Uploaded',
          tmf_doc_country:
            Meta.tmf_doc_level === 'Country' || Meta.tmf_doc_level === 'Site' ? Meta.tmf_doc_country : null,
          tmf_doc_study: Meta.tmf_doc_study,
          tmf_doc_site: Meta.tmf_doc_level === 'Site' ? Meta.tmf_doc_site : null,
          tmf_doc_viewer_department: 'None',
          tmf_doc_viewer_language: 'English',
          tmf_doc_viewer_approval_cycle: 0,
          tmf_doc_viewer_product_detail: 'test1',
          tmf_doc_viewer_ref_model_version: 'TMF RM 3.2.1',
          tmf_doc_viewer_format: data.tmf_doc_type,
          tmf_doc_viewer_inspection_ready: '',
          tmf_doc_viewer_ir_issue_type: '',
          tmf_doc_level: Meta.tmf_doc_level,
          tmf_artifact_name: artifactName,
          tmf_doc_version_number: Meta.tmf_doc_version_number,
          tmf_doc_milestone: Meta.tmf_doc_milestone,
          tmf_document_id: 'str',
          tmf_doc_created_by: userName
        }
      };
      getDocumentDetails(metaData, docData, isSubmit);
    } else if (response.error) {
      if (response.error === 'Request failed with status code 500') {
        store.dispatch(setSnackbarMessage('File name with more than 100 characters is not allowed', 'error'));
      } else {
        store.dispatch(
          setSnackbarMessage(
            t('fileUploadError', {
              returnObjects: true,
              fileName: isFileUploaded.name
            }),
            'error'
          )
        );
      }
      setError(response.error?.message);
      dispatch(hideLoader());
    }
  };

  const postData = async (docData: any, isSubmit: any) => {
    const params = {
      module_section_related: 'DocumentUpload',
      parent_entity_related: '--'
    };
    const res: any = await docService.createMasterDocument(params, docData);

    if (res.error) {
      switch (res.error?.response.status) {
        case 403:
          store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
          break;
        case 401:
          store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
          break;
        default:
          store.dispatch(setSnackbarMessage('Error in uploading document.', 'error'));
      }
    } else {
      setConfirmExitValue(dispatch, false);
      store.dispatch(setSnackbarMessage('Document is uploaded successfully.', 'success'));
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      documentValue(0, pageSize);
      clearData();
      props.setDocUploadComponent(true);
    }
  };

  const handleUpdateFile = (Meta: any, isSave: any) => {
    dispatch(showLoader());
    const docData: any = {
      file_master_id: Meta.fileId,
      document_data: {
        tmf_artifact_number: Meta.tmf_artifact_number ? Meta.tmf_artifact_number : Meta.tmf_doc_artifact_number,
        tmf_document_name: Meta.tmf_document_name,
        tmf_doc_type: Meta.tmf_doc_type ? Meta.tmf_doc_type : Meta.tmf_document_type,
        tmf_doc_subtype: Meta.tmf_doc_subtype ? Meta.tmf_doc_subtype : Meta.tmf_document_subtype,
        tmf_doc_viewer_req_certified_copy: Meta.tmf_doc_viewer_req_certified_copy,
        tmf_doc_status: Meta.tmf_doc_status,
        tmf_doc_country:
          Meta.tmf_doc_level === 'Country' || Meta.tmf_doc_level === 'Site' ? Meta.tmf_doc_country : null,
        tmf_doc_study: Meta.tmf_doc_study,
        tmf_doc_site: Meta.tmf_doc_level === 'Site' ? Meta.tmf_doc_site : null,
        tmf_doc_viewer_department: row.tmf_doc_viewer_department,
        tmf_doc_viewer_language: 'English',
        tmf_doc_viewer_approval_cycle: 0,
        tmf_doc_viewer_product_detail: '',
        tmf_doc_viewer_ref_model_version: 'TMF RM 3.2.1',
        tmf_doc_viewer_format: Meta.tmf_doc_format,
        tmf_doc_viewer_inspection_ready: 'test1',
        tmf_doc_viewer_ir_issue_type: 'test1',
        tmf_doc_level: Meta.tmf_doc_level,
        tmf_artifact_name: Meta.tmf_artifact_name ? Meta.tmf_artifact_name : artifactName,
        tmf_doc_version_number: Meta.tmf_doc_version_number,
        tmf_doc_milestone: Meta.tmf_doc_milestone,
        tmf_document_id: Meta.tmf_document_id,
        id: Meta.id,
        tmf_doc_last_modified_by: userName
      }
    };
    getDocumentDetailsforVersion(Meta, docData, isSave);
  };

  const updateDocumentData = async (docData: any, isSave: any) => {
    const params = {
      module_section_related: 'DocumentUpload',
      parent_entity_related: docData.tmf_document_name
    };
    const res = await docService.updateMasterDocument(params, docData);
    if (res.data) {
      setIsEdited(false);
      store.dispatch(setSnackbarMessage('Document is updated successfully.', 'success'));
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      documentValue(0, pageSize);
      clearData();
      props.setDocUploadComponent(true);
    } else {
      if (res.error && (res.error?.response.status !== 401 || res.error?.response.status !== 403)) {
        store.dispatch(setSnackbarMessage('Error in updating document.', 'error'));
      }
    }
  };
  useEffect(() => {
    if (props.onClicked) {
      props.routeInfo && props.routeInfo('');
      setDataGridComponent(true);
    }
  }, [props.onClicked]);
  useEffect(() => {
    if (dataGridComponent) {
      documentValue(0, pageSize);
    } else {
      props.routeInfo && props.routeInfo('doc_upload');
    }
  }, [dataGridComponent]);

  useEffect(() => {
    if (isPageFirstRendered.current['isRendered']) {
      if (page * pageSize > rowCount - 1) {
        setPage(0);
        documentValue(0, pageSize);
      } else documentValue(page * pageSize, pageSize);
    }
    isPageFirstRendered.current['isRendered'] = true;
  }, [page, pageSize]);

  const handleCountryChange = (e: any) => {
    setCurrentCountry(e.target.value);
    setMetaData({
      ...metaData,
      tmf_doc_country: e.target.value,
      tmf_doc_site: '',
      tmf_artifact_name: '',
      tmf_doc_milestone: '',
      tmf_document_type: '',
      tmf_document_subtype: '',
      tmf_artifact_number: ''
    });
    setDisableSave(false);
    setDocumentDetail(dispatch, [
      { file_master: {} },
      {
        document_data: {
          ...metaData,
          tmf_doc_country: e.target.value
        }
      }
    ]);
  };

  const handleStudyChange = async (value: any) => {
    const resetStudyRelatedFields = {
      tmf_doc_site: '',
      tmf_doc_country: '',
      tmf_artifact_name: '',
      tmf_doc_milestone: '',
      tmf_document_type: '',
      tmf_document_subtype: '',
      tmf_artifact_number: ''
    };
    if (!value) {
      setList([]);
      setMetaData({
        ...metaData,
        tmf_doc_study: '',
        ...resetStudyRelatedFields
      });

      setDocumentDetail(dispatch, [
        { file_master: {} },
        {
          document_data: {
            ...metaData,
            tmf_doc_study: '',
            ...resetStudyRelatedFields
          }
        }
      ]);
    } else {
      setMetaData({
        ...metaData,
        tmf_doc_study: value,
        ...resetStudyRelatedFields
      });
      setDisableSave(false);
      setDocumentDetail(dispatch, [
        { file_master: {} },
        {
          document_data: {
            ...metaData,
            tmf_doc_study: value
          }
        }
      ]);
    }
  };

  const handleChangeTmfLevel = (e: any) => {
    setMetaData({
      ...metaData,
      tmf_doc_level: e.target.value,
      tmf_artifact_name: '',
      tmf_doc_milestone: '',
      tmf_document_type: '',
      tmf_document_subtype: '',
      tmf_artifact_number: '',
      tmf_doc_study: ''
    });
    setCurrentStudy('');
    setCurrentCountry('');
    setCurrentSite('');
    setDisableSave(false);
  };

  const handleSiteChange = (e: any) => {
    setMetaData({
      ...metaData,
      tmf_doc_site: e.target.value,
      tmf_artifact_name: '',
      tmf_doc_milestone: '',
      tmf_document_type: '',
      tmf_document_subtype: '',
      tmf_artifact_number: ''
    });
    setCurrentSite(e.target.value);
    setDocumentDetail(dispatch, [
      { file_master: {} },
      {
        document_data: {
          ...metaData,
          tmf_doc_site: e.target.value
        }
      }
    ]);
  };

  const handleChangeArtifactName = (e: any) => {
    if (!e) {
      setArtifactName(e);
      setMetaData({
        ...metaData,
        tmf_artifact_name: '',
        tmf_doc_milestone: '',
        tmf_document_type: '',
        tmf_document_subtype: '',
        tmf_artifact_number: ''
      });
      setDocumentDetail(dispatch, [
        { file_master: {} },
        {
          document_data: {
            ...metaData,
            tmf_artifact_name: '',
            tmf_doc_milestone: '',
            tmf_doc_type: '',
            tmf_doc_subtype: '',
            tmf_artifact_number: ''
          }
        }
      ]);
    } else {
      setArtifactName(e);
      setDisableSave(false);
      getArtifactNameResponse(e);
    }
  };

  /**
   * Bharath
   */
  const [currentStudy, setCurrentStudy] = useState('');
  const [currentCountry, setCurrentCountry] = useState('');
  const [countryList, setCountryList] = useState<any>([]);
  const [siteList, setSiteList] = useState<any>([]);

  const {
    isLoading: getStudyLoad,
    data: studyData,
    isError: getStudyError,
    isSuccess: getStudySuccess,
    refetch: getStudyList
  } = useGetStudiesQuery();

  useEffect(() => {
    const temp: string[] = [];
    if (studyData && studyData.length != 0) {
      studyData.map((study: any) => {
        temp.push(study.name);
      });
    }
    setStudyList(temp);
  }, [studyData]);

  const {
    isLoading,
    data: countryData,
    isError,
    isSuccess,
    refetch: getCountries
  } = useGetCountriesQuery(currentStudy);

  useEffect(() => {
    if (!currentStudy) return;

    const fetchData = async () => {
      if (metaData.tmf_doc_level === 'Study') {
        getArtifactNameListBasedStudyCountrySite(currentStudy, '--', '--');
      } else {
        await getCountries();
        if (metaData.tmf_doc_level === 'Country') {
          if (currentCountry) {
            getArtifactNameListBasedStudyCountrySite(currentStudy, currentCountry, '--');
          }
        } else if (metaData.tmf_doc_level === 'Site') {
          await getSites();
          if (currentCountry && currentSite) {
            getArtifactNameListBasedStudyCountrySite(currentStudy, currentCountry, currentSite);
          }
        }
      }
    };

    fetchData();
  }, [currentStudy, currentCountry, currentSite]);

  useEffect(() => {
    const tempC: any = [];
    if (countryData && countryData.length != 0 && !isError) {
      countryData.map((country: any) => {
        tempC.push(country.name);
      });
      setCountryList(tempC);
    } else {
      setCountryList([]);
    }
  }, [countryData, isError]);

  const {
    isLoading: getSiteLoading,
    data: sitesData,
    isError: getSiteError,
    isSuccess: getSiteSuccess,
    refetch: getSites
  } = useGetSitesQuery({ currentStudy, currentCountry });

  useEffect(() => {
    const tempS: string[] = [];

    if (sitesData && sitesData.length != 0 && !getSiteError) {
      sitesData.map((site: any) => {
        tempS.push(site.name);
      });
      setSiteList(tempS);
    } else {
      setSiteList([]);
    }
  }, [sitesData, getSiteError]);

  const getArtifactNameListBasedStudyCountrySite = async (study: string, country: string, site: string) => {
    dispatch(showLoader());
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: metaData.tmf_document_name
    };
    try {
      const result: any = await docService.getArtifactsList(
        metaData.tmf_doc_level ? metaData.tmf_doc_level : TmfLevel,
        study,
        country,
        site,
        params
      );

      if (result.data) {
        setList(result.data);
        setArtifactsError(false);
        dispatch(hideLoader());
      } else {
        setArtifactsError(true);
        setList([]);
        dispatch(hideLoader());
      }
    } catch (err: any) {
      setArtifactsError(true);
      setList([]);
      dispatch(hideLoader());
    }
  };

  const handleDocumentName = (e: any) => {
    setMetaData({ ...metaData, tmf_document_name: e.target.value });
    setDisableSave(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getStudyList();
    return () => {
      props.routeInfo && props.routeInfo('');
    };
  }, []);

  const today = new Date();

  const documentValue = async (from: number, size: number) => {
    setLoading(true);
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: '--'
    };
    const response: any = await docService.getMasterDocumentsByUser(
      false,
      '',
      '',
      '',
      'None',
      params,
      true,
      from,
      size
    );

    if (response.data) {
      setLoading(false);
      const documentDataTotal = response.data?.selected_data?.map((el: any) => {
        el.file_master.fmId = el.file_master.id; //  to preserve the document id of file_master temporarily
        el.document_data.fileId = el.file_master.id;
        el.file_master.docFormat = el.file_master.tmf_doc_type; //  to preserve the doc format of file_master because we have two fields with tmf_doc_type in both file_master and Documemt_data which is overwritten.
        el.document_data.hashed_uri_key = el.hashed_uri_key;
        return el;
      });
      const comData = documentDataTotal.map(
        (respo: { document_data: any; file_master: any }) => [{ ...respo.file_master, ...respo.document_data }][0]
      );
      setResult(comData);
      setRowCount(response.data.record_count);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isEdit) {
      setFileUploaded(true);
      setMetaData({
        ...metaData,
        id: row.id,
        tmf_artifact_number: row.tmf_artifact_number,
        tmf_document_name: row.tmf_document_name,
        tmf_document_type: row.tmf_doc_type,
        tmf_document_subtype: row.tmf_doc_subtype,
        tmf_doc_date: row.tmf_doc_date.split('T')[0],
        tmf_doc_country: row.tmf_doc_country,
        tmf_doc_study: row.tmf_doc_study,
        tmf_doc_site: row.tmf_doc_site,
        tmf_doc_level: row.tmf_doc_level,
        tmf_artifact_name: row.tmf_artifact_name,
        tmf_doc_version_number: row.tmf_doc_version_number,
        tmf_doc_milestone: row.tmf_doc_milestone,
        fileId: row.fileId,
        tmf_doc_viewer_req_certified_copy: row.tmf_doc_viewer_req_certified_copy,
        tmf_document_id: row.tmf_document_id,
        tmf_doc_status: row.tmf_doc_status
      });
      setDisableSave(true);
      setCurrentStudy(row.tmf_doc_study);
      setCurrentCountry(row.tmf_doc_country);
      setArtifactName(row.tmf_artifact_name);
      getArtifactNameList(row.tmf_doc_level);
    }
  }, [row]);

  const getArtifactNameList = async (tmf_level: any) => {
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: metaData.tmf_document_name
    };
    const tmf_doc_site = currentSite ? currentSite : selectedSite;
    const result: any = await docService.getArtifactsList(
      tmf_level,
      selectedStudy,
      selectedCountry,
      tmf_doc_site,
      params
    );

    if (result.data) {
      setList(result.data);
      setArtifactsError(false);
    }
  };

  const getArtifactNameResponse = async (e: any) => {
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: metaData.tmf_document_name
    };
    const result: any = await docService.getArtifactNameResponse(
      metaData.tmf_doc_level ? metaData.tmf_doc_level : TmfLevel,
      e,
      currentStudy,
      currentCountry,
      currentSite,
      params
    );
    if (result.data) {
      setMetaData({
        ...metaData,
        tmf_artifact_name: e,
        tmf_artifact_number: result.data?.tmf_artifact_number,
        tmf_document_subtype: result.data?.tmf_doc_subtype,
        tmf_document_type: result.data?.tmf_doc_type,
        tmf_doc_milestone: result.data?.tmf_doc_milestone
      });

      setDocumentDetail(dispatch, [
        { file_master: {} },
        {
          document_data: {
            ...metaData,
            tmf_artifact_number: result.data.tmf_artifact_number,
            tmf_doc_subtype: result.data.tmf_doc_subtype,
            tmf_doc_type: result.data.tmf_doc_type,
            tmf_doc_milestone: result.data.tmf_doc_milestone
          }
        }
      ]);
    }
  };

  const clearData = () => {
    setIsVersionCheck(false);
    setMetaData({ ...InitialState });
    setEditDoc({ editDoc: { isEdit: false } });
    setIsEdited(false);
    setStyleUpload('uploadFile');
    setUploaded(false);
    setEnable(false);
    setFileUploading(false);
    setConfirmExitValue(dispatch, false);
    setConfirmExitPopupVal(dispatch, false);
    props.setDocUploadComponent(true);
    setDocumentDetail(dispatch, [
      { file_master: {} },
      {
        document_data: {
          ...InitialState
        }
      }
    ]);
    setFileUploaded(null);
  };
  /**
   * File upload rejected.
   *
   * @param rejectedFile
   * @param acceptedFiles
   * @param maxFileSize
   * @returns
   */
  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `;
    const arrFile = rejectedFile.name.split('.');
    if (rejectedFile.size > maxFileSize) {
      message += `File is too big. Max File Size is 5MB`;
    } else if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported.
      Supported file formats are jpg, jpeg, gif, png, bmp, tif, psd, pdf, doc, docx, xls, xlsx.`;
    }
    return message;
  };

  const handleDialogBox = () => {
    setEnable(true);
  };
  const handleClose = () => {
    setEnable(false);
  };

  const handleCloseVersion = () => {
    setOpenVersion(false);
    setMetaData({ ...InitialState });
    if (dataGridComponent) {
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      documentValue(0, pageSize);
      clearData();
      props.setDocUploadComponent(true);
    }
  };

  const handleClosePropVersion = () => {
    setOpenEditDocVersion(false);
  };

  const getDocumentDetails = async (metaData: any, docData: any, isSubmit: any) => {
    const is_scope = metaData.tmf_doc_study === '--' ? false : true;
    const country =
      metaData.tmf_doc_level === 'Country' || metaData.tmf_doc_level === 'Site' ? metaData.tmf_doc_country : '--';
    const site = metaData.tmf_doc_level === 'Site' ? metaData.tmf_doc_site : '--';
    const data = {
      query_filters: [
        {
          name: 'tmf_doc_level',
          value: metaData.tmf_doc_level,
          operation: 'equals'
        },
        {
          name: 'tmf_artifact_name',
          value: artifactName ? artifactName : rowDetails.data[0]?.tmf_artifact_name,
          operation: 'equals'
        }
      ],
      filter_types: ['All']
    };
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: metaData.tmf_document_name
    };
    const res: any = await docService.getDocumentDetails(
      data,
      country,
      site,
      metaData.tmf_doc_study,
      is_scope,
      metaData.tmf_doc_level ? metaData.tmf_doc_level : TmfLevel,
      params
    );
    if (res.data) {
      setSelectData(res.data.selected_data[0]);
      (metaData.tmf_doc_level === res.data?.selected_data[0]?.document_data.tmf_doc_level &&
        metaData.tmf_doc_study === res.data?.selected_data[0]?.document_data.tmf_doc_study &&
        metaData.tmf_artifact_name === res.data?.selected_data[0]?.document_data.tmf_artifact_name) ||
      metaData.tmf_doc_country === res.data?.selected_data[0]?.document_data.tmf_doc_country ||
      metaData.tmf_doc_site === res.data?.selected_data[0]?.document_data.tmf_doc_site
        ? setOpenVersion(true)
        : postData(docData, isSubmit);
    } else {
      postData(docData, isSubmit);
      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      clearData();
    }
    dispatch(hideLoader());
  };

  // Called when Version is to check //
  useEffect(() => {
    if (isEdit) {
      if (
        row.tmf_document_name !== metaData.tmf_document_name ||
        row.tmf_doc_level !== metaData.tmf_doc_level ||
        row.tmf_doc_study !== metaData.tmf_doc_study ||
        row.tmf_doc_country !== metaData.tmf_doc_country ||
        row.tmf_doc_site !== metaData.tmf_doc_site ||
        row.tmf_artifact_name !== metaData.tmf_artifact_name
      ) {
        setConfirmExitValue(dispatch, true);
      } else {
        setConfirmExitValue(dispatch, false);
      }
      if (Number(row.tmf_doc_version_number) > 1.0) {
        setIsVersionCheck(true);
      } else {
        setIsVersionCheck(false);
      }
    }
  }, [row, metaData]);

  const getDocumentDetailsforVersion = async (metaData: any, docData: any, isSave: any) => {
    const is_scope = metaData.tmf_doc_study === '--' ? false : true;
    const country =
      metaData.tmf_doc_level === 'Country' || metaData.tmf_doc_level === 'Site' ? metaData.tmf_doc_country : '--';
    const site = metaData.tmf_doc_level === 'Site' ? metaData.tmf_doc_site : '--';
    const data = {
      query_filters: [
        {
          name: 'tmf_doc_level',
          value: metaData.tmf_doc_level,
          operation: 'equals'
        },
        {
          name: 'tmf_artifact_name',
          value: artifactName,
          operation: 'equals'
        }
      ],
      filter_types: ['All']
    };
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: metaData.tmf_document_name
    };
    const res: any = await docService.getDocumentDetails(
      data,
      country,
      site,
      metaData.tmf_doc_study,
      is_scope,
      metaData.tmf_doc_level ? metaData.tmf_doc_level : TmfLevel,
      params
    );
    if (res.data && !IsVersionCheck) {
      (metaData.tmf_doc_level === res.data?.selected_data[0]?.document_data.tmf_doc_level &&
        metaData.tmf_doc_study === res.data?.selected_data[0]?.document_data.tmf_doc_study &&
        metaData.tmf_artifact_name === res.data?.selected_data[0]?.document_data.tmf_artifact_name) ||
      metaData.tmf_doc_country === res.data?.selected_data[0]?.document_data.tmf_doc_country ||
      metaData.tmf_doc_site === res.data?.selected_data[0]?.document_data.tmf_doc_site
        ? metaData.tmf_document_name !== res.data?.selected_data[0]?.document_data.tmf_document_name &&
          row.tmf_document_id === res.data?.selected_data[0]?.document_data.tmf_document_id
          ? updateDocumentData(docData, isSave)
          : store.dispatch(
              setSnackbarMessage(
                'Document exists with same context. Please select different values to proceed',
                'error'
              )
            )
        : updateDocumentData(docData, isSave);
    } else {
      updateDocumentData(docData, isSave);
    }
    dispatch(hideLoader());
  };

  useEffect(() => {
    if (metaData?.tmf_artifact_name) {
      setDisableDropzone(false);
      setAddonStyle(' uploadFile');
    } else {
      setDisableDropzone(false);
      setAddonStyle(' noUploadFile');
    }
  }, [metaData?.tmf_artifact_name]);

  useEffect(() => {
    if (getStudyLoad || isLoading || getSiteLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [getStudyLoad, isLoading, getSiteLoading]);

  return (
    <div className="document-upload-page">
      {dataGridComponent ? (
        <div>
          <>
            <div className="card">
              <Grid container spacing={3}>
                <Grid id="uploadFile" item md={12} sm={12} xs={12}>
                  {isEdit ? (
                    <div className="edit-file-section">
                      <div>
                        <InsertDriveFileIcon style={{ fontSize: '49px', color: '#979797' }} />
                      </div>
                      <Link>{row.tmf_raw_file_name}</Link>
                      <Typography variant="h5" fontSize="20px">
                        Your file upload has been successfully initiated
                      </Typography>
                    </div>
                  ) : (
                    <DocumentUploadComponent
                      onFileUploadSuccess={onFileUploadSuccess}
                      handleRejectedMessage={handleRejectedMessage}
                      setStyleUpload={setStyleUpload}
                      styleUpload={styleUpload}
                      isUploaded={isUploaded}
                      setUploaded={setUploaded}
                      tmfLevel={metaData.tmf_doc_level}
                      TmfLevel={TmfLevel}
                      disableDropzone={disableDropzone}
                      addonStyle={addonStyle}
                      error={error}
                      setError={setError}
                      progress={progress}
                      setProgress={setProgress}
                      isFileUploading={isFileUploading}
                      setFileUploading={setFileUploading}
                      tmf_artifact_name={metaData.tmf_artifact_name}
                    />
                  )}
                </Grid>
                <Grid item md={12} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item md={4} sm={12} xs={12}>
                      <FormControl fullWidth margin="normal">
                        <TextField
                          required
                          id="standard-select-currency-native"
                          label="Document Name "
                          variant="standard"
                          inputProps={{
                            maxLength: 200
                          }}
                          onChange={e => handleDocumentName(e)}
                          value={metaData.tmf_document_name.trimLeft()}
                        />
                      </FormControl>

                      <FormControl fullWidth margin="normal">
                        <TextField
                          disabled={!metaData.tmf_doc_level || metaData.tmf_doc_level === 'Study' || IsVersionCheck}
                          required={metaData.tmf_doc_level === 'Country' || metaData.tmf_doc_level === 'Site'}
                          id="standard-select-currency-native"
                          select
                          label="Country"
                          onChange={(e: any) => handleCountryChange(e)}
                          value={metaData.tmf_doc_level === 'Study' ? '' : metaData.tmf_doc_country}
                          variant="standard"
                        >
                          <MenuItem value=""></MenuItem>
                          {countryList.map((item: string, i: number) => (
                            <MenuItem value={item} key={i}>
                              {item}
                            </MenuItem>
                          ))}
                        </TextField>
                      </FormControl>

                      <FormControl fullWidth margin="normal">
                        <TextField
                          disabled={(isEdit ? false : disabled) || IsVersionCheck || !isFileUploaded}
                          id="standard-select-currency-native"
                          label="Version Number"
                          variant="standard"
                          value={
                            isFileUploaded && metaData.tmf_doc_version_number !== 0
                              ? parseFloat(metaData.tmf_doc_version_number).toFixed(1)
                              : isEdit
                              ? parseFloat(metaData.tmf_doc_version_number).toFixed(1)
                              : ''
                          }
                        ></TextField>
                      </FormControl>

                      <FormControl fullWidth margin="normal">
                        <TextField
                          disabled={(isEdit ? false : !artifactName) || IsVersionCheck || !metaData?.tmf_artifact_name}
                          id="standard-select-currency-native"
                          label="Subtype"
                          variant="standard"
                          value={metaData.tmf_document_subtype}
                        ></TextField>
                      </FormControl>
                    </Grid>
                    <Grid item md={4} sm={12} xs={12}>
                      <FormControl fullWidth margin="normal">
                        <TextField
                          disabled={IsVersionCheck}
                          required
                          id="standard-required"
                          select
                          label="TMF Level"
                          defaultValue=""
                          value={metaData.tmf_doc_level}
                          variant="standard"
                          onChange={e => {
                            handleChangeTmfLevel(e);
                          }}
                        >
                          {tmfLevelConfigs.map((menuItem: any) => {
                            return (
                              <MenuItem key={menuItem.key} value={tmfLevelLocale[menuItem.key]}>
                                {tmfLevelLocale[menuItem.key]}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                        {tmfLevelLoading && (
                          <CircularProgress
                            size={18}
                            sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '100%',
                              marginTop: '-4px',
                              marginLeft: '-20px'
                            }}
                          />
                        )}
                      </FormControl>
                      <FormControl fullWidth margin="normal">
                        <TextField
                          disabled={
                            !metaData.tmf_doc_level ||
                            metaData.tmf_doc_level === 'Study' ||
                            metaData.tmf_doc_level === 'Country' ||
                            IsVersionCheck
                          }
                          required={metaData.tmf_doc_level === 'Site'}
                          id="standard-select-currency-native"
                          select
                          value={
                            metaData.tmf_doc_level === 'Study' || metaData.tmf_doc_level === 'Country'
                              ? ''
                              : metaData.tmf_doc_site
                          }
                          label="Site"
                          variant="standard"
                          onChange={e => {
                            handleSiteChange(e);
                          }}
                        >
                          <MenuItem value=""></MenuItem>
                          {siteList.map((item: string, i: number) => (
                            <MenuItem value={item} key={i}>
                              {item}
                            </MenuItem>
                          ))}
                        </TextField>
                      </FormControl>

                      <FormControl fullWidth margin="normal">
                        <TextField
                          disabled={(isEdit ? false : !artifactName) || IsVersionCheck || !metaData.tmf_artifact_name}
                          id="standard-select-currency-native"
                          label="Milestone"
                          variant="standard"
                          value={metaData.tmf_doc_milestone}
                        ></TextField>
                      </FormControl>

                      <FormControl fullWidth margin="normal">
                        <TextField
                          disabled={(isEdit ? false : !artifactName) || IsVersionCheck || !metaData.tmf_artifact_name}
                          id="standard-select-currency-native"
                          label="Artifact Number"
                          variant="standard"
                          value={metaData.tmf_artifact_number}
                        ></TextField>
                      </FormControl>
                    </Grid>
                    <Grid item md={4} sm={12} xs={12}>
                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          disablePortal
                          disabled={!metaData.tmf_doc_level || IsVersionCheck}
                          id="standard-select-currency-native"
                          options={studyList}
                          value={metaData.tmf_doc_study}
                          onChange={(e: any, newValue: string) => {
                            setCurrentStudy(newValue);
                            handleStudyChange(newValue);
                          }}
                          renderInput={params => <TextField {...params} required label="Study" variant="standard" />}
                        />
                      </FormControl>

                      <FormControl fullWidth margin="normal">
                        <Autocomplete
                          disabled={!metaData.tmf_doc_level || IsVersionCheck}
                          disablePortal
                          readOnly={metaData.tmf_doc_level === ''}
                          id="standard-select-currency-native"
                          options={list}
                          value={metaData.tmf_artifact_name}
                          onChange={(event: any, newValue: string | null) => handleChangeArtifactName(newValue)}
                          renderInput={params => (
                            <TextField {...params} required label="Artifact Name" variant="standard" />
                          )}
                        />
                        {tmfLevelLoading && (
                          <CircularProgress
                            size={18}
                            sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '100%',
                              marginTop: '-4px',
                              marginLeft: '-20px'
                            }}
                          />
                        )}
                      </FormControl>

                      <FormControl fullWidth margin="normal">
                        <TextField
                          disabled={(isEdit ? false : !artifactName) || IsVersionCheck || !metaData.tmf_artifact_name}
                          id="standard-select-currency-native"
                          label="Type"
                          variant="standard"
                          value={metaData.tmf_document_type}
                        ></TextField>
                      </FormControl>

                      <FormControl fullWidth margin="normal">
                        <TextField
                          disabled
                          id="standard-select-currency-native"
                          label="Upload Date"
                          variant="standard"
                          value={
                            isFileUploaded
                              ? metaData.tmf_doc_date
                                ? moment(new Date(metaData.tmf_doc_date)).format(userPreferedDateFormat.toUpperCase())
                                : ''
                              : isEdit
                              ? moment(new Date(metaData.tmf_doc_date)).format(userPreferedDateFormat.toUpperCase())
                              : ''
                          }
                        ></TextField>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} display="flex" justifyContent="flex-end">
                      <Stack direction="row" spacing={2}>
                        <Button
                          href="#contained-buttons"
                          className="grey-btn"
                          onClick={handleDialogBox}
                          disabled={
                            !isFileUploaded &&
                            !metaData.tmf_doc_level &&
                            !metaData.tmf_doc_study &&
                            !metaData.tmf_artifact_number &&
                            !metaData.tmf_document_name
                          }
                        >
                          Cancel
                        </Button>
                        <PopupComponent
                          open={enable}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                          className="confirm-modal"
                        >
                          <DialogTitle id="alert-dialog-title">{'Document upload?'}</DialogTitle>
                          <DialogContent sx={{ minWidth: 500 }}>
                            <DialogContentText id="alert-dialog-description">
                              {isFileUploaded
                                ? 'Do you want to cancel document upload ?'
                                : 'Do you want to cancel the page?'}
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={clearData} autoFocus className="grey-btn">
                              Yes
                            </Button>
                            <Button onClick={handleClose}>No</Button>
                          </DialogActions>
                        </PopupComponent>
                        {isEdit ? (
                          <Button
                            onClick={() => handleUpdateFile(metaData, true)}
                            disabled={
                              disableSave ||
                              !metaData.tmf_document_name.trim() ||
                              !metaData.tmf_doc_level ||
                              !metaData.tmf_doc_study ||
                              !metaData.tmf_artifact_number
                            }
                          >
                            Save
                          </Button>
                        ) : (
                          <Button
                            onClick={() => handleUploadFile(resData, metaData, artifactName, true)}
                            disabled={
                              metaData.tmf_doc_level === 'Study'
                                ? !isFileUploaded ||
                                  !metaData.tmf_doc_level ||
                                  !metaData.tmf_doc_study ||
                                  !metaData.tmf_artifact_number ||
                                  !metaData.tmf_document_name.trim()
                                : metaData.tmf_doc_level === 'Country'
                                ? !isFileUploaded ||
                                  !metaData.tmf_doc_level ||
                                  !metaData.tmf_doc_study ||
                                  !metaData.tmf_doc_country ||
                                  !metaData.tmf_artifact_number ||
                                  !metaData.tmf_document_name.trim()
                                : metaData.tmf_doc_level === 'Site'
                                ? !isFileUploaded ||
                                  !metaData.tmf_doc_level ||
                                  !metaData.tmf_doc_study ||
                                  !metaData.tmf_doc_country ||
                                  !metaData.tmf_doc_site ||
                                  !metaData.tmf_artifact_number ||
                                  !metaData.tmf_document_name.trim()
                                : true
                            }
                          >
                            Submit
                          </Button>
                        )}
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
            <DocumentUploadList
              result={result}
              rowCount={rowCount}
              setDataGridComponent={setDataGridComponent}
              setDocumentToDisplay={setDocumentToDisplay}
              setEditDoc={setEditDoc}
              handleDialogBox={handleDialogBox}
              loading={loading}
              setStyleUpload={setStyleUpload}
              setUploaded={setUploaded}
              documentValue={documentValue}
              ClearData={clearData}
              setFileUploaded={setFileUploaded}
              isEdited={isEdited}
              setIsEdited={setIsEdited}
              pageSize={pageSize}
              setPage={setPage}
              setPageSize={setPageSize}
              page={page}
            />

            <PopupComponent maxWidth="sm" open={openVersion}>
              <VersionControl
                setDocUploadComponent={props.setDocUploadComponent}
                resData={resData}
                metaData={metaData}
                selectData={selectData}
                setSelectData={setSelectData}
                setMetaData={setMetaData}
                handleCloseVersion={handleCloseVersion}
                artifactName={artifactName}
                setStyleUpload={setStyleUpload}
                setUploaded={setUploaded}
                documentValue={documentValue}
                ClearData={clearData}
                setFileUploaded={setFileUploaded}
              />
            </PopupComponent>
          </>
        </div>
      ) : (
        <div>
          {props.docViewer ? (
            ''
          ) : (
            <DocumentViewerComponent
              documentDetails={documentToDisplay}
              props={props}
              setDataGridComponent={setDataGridComponent}
            />
          )}
          {openEditDocVersion ? (
            <Dialog maxWidth="sm" open={openEditDocVersion}>
              <VersionControl
                resData={resData}
                metaData={metaData}
                selectData={documentDetail.data[0]}
                docViewer={true}
                setMetaData={setMetaData}
                handleCloseVersion={handleClosePropVersion}
                artifactName={artifactName}
                editedFmID={props.editedFmID}
                setOpenEditDocVersion={setOpenEditDocVersion}
              />
            </Dialog>
          ) : (
            ''
          )}
        </div>
      )}
    </div>
  );
};
